/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Pos_viewer$ref = any;
export type routes_Pos_QueryVariables = {|
  forklift?: ?boolean,
  street?: ?string,
  suburb?: ?string,
  postcode?: ?string,
  useCredit?: ?boolean,
  useLoyaltyPoints?: ?boolean,
  shippingMethod?: ?string,
  ccType?: ?string,
  stripeToken?: ?string,
|};
export type routes_Pos_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Pos_viewer$ref
  |}
|};
export type routes_Pos_Query = {|
  variables: routes_Pos_QueryVariables,
  response: routes_Pos_QueryResponse,
|};
*/


/*
query routes_Pos_Query(
  $forklift: Boolean
  $useCredit: Boolean
  $useLoyaltyPoints: Boolean
  $shippingMethod: String
  $ccType: String
  $stripeToken: String
) {
  viewer {
    ...Pos_viewer_3LxzhD
    id
  }
}

fragment FreebiePopup_cart on Cart {
  freebies(first: 99) {
    edges {
      node {
        id
        mode
        products(first: 99) {
          edges {
            node {
              id
              name
              urlSlug
              mainImage {
                id
                url
                thumbnail
              }
            }
          }
        }
      }
    }
  }
}

fragment FreebiePopup_viewer on Customer {
  id
}

fragment ItemList_viewer on Customer {
  ...FreebiePopup_viewer
  configs
  cart {
    id
    subtotal
    grandTotal
    loyaltyPoints {
      accruing
    }
    storeCredits(first: 999) {
      edges {
        node {
          id
          name
          stealthMode
          creditAmount
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    isOptFreebiesInCart
    lines(first: 999) {
      edges {
        node {
          id
          name
          isFreebie
          unitPrice
          quantity
          rowTotal
          unitDiscount
          unitSurcharge
          configParent {
            id
            urlSlug
            mainImage {
              id
              thumbnail
            }
          }
          priorityShipping {
            getByDate
          }
          product {
            id
            sku
            name
            urlSlug
            nonStock
            onlineOnly
            preorderDate
            backInStockDate
            stockAvailable
            clearance
            limitedStock
            priorityShipping {
              getByDate
            }
            brand {
              id
              name
            }
            mainImage {
              id
              thumbnail
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    ...FreebiePopup_cart
    freebies(first: 99) {
      edges {
        node {
          id
          mode
          products(first: 99) {
            edges {
              node {
                id
                name
                urlSlug
                mainImage {
                  id
                  url
                  thumbnail
                }
              }
            }
          }
        }
      }
    }
    stores(first: 9999) {
      edges {
        node {
          id
          stocks {
            productId
            stock
          }
        }
      }
    }
  }
}

fragment Pos_viewer_3LxzhD on Customer {
  ...FreebiePopup_viewer
  cart {
    id
    checkoutSnapshot
    subtotal
    shippingCost(shippingMethod: $shippingMethod)
    grandTotal
    surcharges(ccType: $ccType, stripeToken: $stripeToken, forklift: $forklift) {
      name
      amount
      id
    }
    discount
    discounts(useCredit: $useCredit, useLoyaltyPoints: $useLoyaltyPoints) {
      id
      name
      amount
      removable
    }
    isOptFreebiesInCart
    lines(first: 999) {
      edges {
        node {
          id
          name
          isFreebie
          unitPrice
          quantity
          unitDiscount
          unitSurcharge
          rowTotal
          product {
            id
            sku
            brand {
              id
              name
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    ...FreebiePopup_cart
  }
  stores(first: 999) {
    edges {
      node {
        id
        name
        address
        city
        postcode
        state
        description
        phone
        lat
        lng
        canPickup
        excludeBulkyGood
      }
    }
  }
  ...ItemList_viewer
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ccType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forklift"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postcode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shippingMethod"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "street"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stripeToken"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "suburb"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useCredit"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useLoyaltyPoints"
},
v9 = {
  "kind": "Variable",
  "name": "ccType",
  "variableName": "ccType"
},
v10 = {
  "kind": "Variable",
  "name": "forklift",
  "variableName": "forklift"
},
v11 = {
  "kind": "Variable",
  "name": "shippingMethod",
  "variableName": "shippingMethod"
},
v12 = {
  "kind": "Variable",
  "name": "stripeToken",
  "variableName": "stripeToken"
},
v13 = {
  "kind": "Variable",
  "name": "useCredit",
  "variableName": "useCredit"
},
v14 = {
  "kind": "Variable",
  "name": "useLoyaltyPoints",
  "variableName": "useLoyaltyPoints"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PriorityShipping",
  "kind": "LinkedField",
  "name": "priorityShipping",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "getByDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductImage",
  "kind": "LinkedField",
  "name": "mainImage",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_Pos_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "kind": "Variable",
                "name": "postcode",
                "variableName": "postcode"
              },
              (v11/*: any*/),
              {
                "kind": "Variable",
                "name": "street",
                "variableName": "street"
              },
              (v12/*: any*/),
              {
                "kind": "Variable",
                "name": "suburb",
                "variableName": "suburb"
              },
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "Pos_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "routes_Pos_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Cart",
            "kind": "LinkedField",
            "name": "cart",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "checkoutSnapshot",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subtotal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v11/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "shippingCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grandTotal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v12/*: any*/)
                ],
                "concreteType": "Surcharge",
                "kind": "LinkedField",
                "name": "surcharges",
                "plural": true,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "concreteType": "Discount",
                "kind": "LinkedField",
                "name": "discounts",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "removable",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOptFreebiesInCart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "QuoteLineConnection",
                "kind": "LinkedField",
                "name": "lines",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QuoteLineEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QuoteLine",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isFreebie",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quantity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitDiscount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitSurcharge",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rowTotal",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sku",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Brand",
                                "kind": "LinkedField",
                                "name": "brand",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v16/*: any*/),
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "nonStock",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "onlineOnly",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "preorderDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "backInStockDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "stockAvailable",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "clearance",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "limitedStock",
                                "storageKey": null
                              },
                              (v20/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "configParent",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v19/*: any*/),
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/)
                ],
                "storageKey": "lines(first:999)"
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "CartView_lines",
                "kind": "LinkedHandle",
                "name": "lines"
              },
              {
                "alias": null,
                "args": (v26/*: any*/),
                "concreteType": "FreebieTierConnection",
                "kind": "LinkedField",
                "name": "freebies",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreebieTierEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FreebieTier",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v26/*: any*/),
                            "concreteType": "ProductConnection",
                            "kind": "LinkedField",
                            "name": "products",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductImage",
                                        "kind": "LinkedField",
                                        "name": "mainImage",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "products(first:99)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "freebies(first:99)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LoyaltyPoints",
                "kind": "LinkedField",
                "name": "loyaltyPoints",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accruing",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "concreteType": "StoreCreditConnection",
                "kind": "LinkedField",
                "name": "storeCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreCreditEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreCredit",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stealthMode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "creditAmount",
                            "storageKey": null
                          },
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/)
                ],
                "storageKey": "storeCredits(first:999)"
              },
              {
                "alias": null,
                "args": (v18/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "CartView_storeCredits",
                "kind": "LinkedHandle",
                "name": "storeCredits"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 9999
                  }
                ],
                "concreteType": "StoreConnection",
                "kind": "LinkedField",
                "name": "stores",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Store",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StockLevel",
                            "kind": "LinkedField",
                            "name": "stocks",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "stock",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "stores(first:9999)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "StoreConnection",
            "kind": "LinkedField",
            "name": "stores",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "address",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "city",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "postcode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lng",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canPickup",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "excludeBulkyGood",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "stores(first:999)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "configs",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "750a3a05848704334ec95fe0600f537e",
    "id": null,
    "metadata": {},
    "name": "routes_Pos_Query",
    "operationKind": "query",
    "text": "query routes_Pos_Query(\n  $forklift: Boolean\n  $useCredit: Boolean\n  $useLoyaltyPoints: Boolean\n  $shippingMethod: String\n  $ccType: String\n  $stripeToken: String\n) {\n  viewer {\n    ...Pos_viewer_3LxzhD\n    id\n  }\n}\n\nfragment FreebiePopup_cart on Cart {\n  freebies(first: 99) {\n    edges {\n      node {\n        id\n        mode\n        products(first: 99) {\n          edges {\n            node {\n              id\n              name\n              urlSlug\n              mainImage {\n                id\n                url\n                thumbnail\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment FreebiePopup_viewer on Customer {\n  id\n}\n\nfragment ItemList_viewer on Customer {\n  ...FreebiePopup_viewer\n  configs\n  cart {\n    id\n    subtotal\n    grandTotal\n    loyaltyPoints {\n      accruing\n    }\n    storeCredits(first: 999) {\n      edges {\n        node {\n          id\n          name\n          stealthMode\n          creditAmount\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    isOptFreebiesInCart\n    lines(first: 999) {\n      edges {\n        node {\n          id\n          name\n          isFreebie\n          unitPrice\n          quantity\n          rowTotal\n          unitDiscount\n          unitSurcharge\n          configParent {\n            id\n            urlSlug\n            mainImage {\n              id\n              thumbnail\n            }\n          }\n          priorityShipping {\n            getByDate\n          }\n          product {\n            id\n            sku\n            name\n            urlSlug\n            nonStock\n            onlineOnly\n            preorderDate\n            backInStockDate\n            stockAvailable\n            clearance\n            limitedStock\n            priorityShipping {\n              getByDate\n            }\n            brand {\n              id\n              name\n            }\n            mainImage {\n              id\n              thumbnail\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    ...FreebiePopup_cart\n    freebies(first: 99) {\n      edges {\n        node {\n          id\n          mode\n          products(first: 99) {\n            edges {\n              node {\n                id\n                name\n                urlSlug\n                mainImage {\n                  id\n                  url\n                  thumbnail\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    stores(first: 9999) {\n      edges {\n        node {\n          id\n          stocks {\n            productId\n            stock\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment Pos_viewer_3LxzhD on Customer {\n  ...FreebiePopup_viewer\n  cart {\n    id\n    checkoutSnapshot\n    subtotal\n    shippingCost(shippingMethod: $shippingMethod)\n    grandTotal\n    surcharges(ccType: $ccType, stripeToken: $stripeToken, forklift: $forklift) {\n      name\n      amount\n      id\n    }\n    discount\n    discounts(useCredit: $useCredit, useLoyaltyPoints: $useLoyaltyPoints) {\n      id\n      name\n      amount\n      removable\n    }\n    isOptFreebiesInCart\n    lines(first: 999) {\n      edges {\n        node {\n          id\n          name\n          isFreebie\n          unitPrice\n          quantity\n          unitDiscount\n          unitSurcharge\n          rowTotal\n          product {\n            id\n            sku\n            brand {\n              id\n              name\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    ...FreebiePopup_cart\n  }\n  stores(first: 999) {\n    edges {\n      node {\n        id\n        name\n        address\n        city\n        postcode\n        state\n        description\n        phone\n        lat\n        lng\n        canPickup\n        excludeBulkyGood\n      }\n    }\n  }\n  ...ItemList_viewer\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '43b361bd26683bbcfcc35a9a07430989';

module.exports = node;
